import React from "react";
import { isBrandingConfigLoaded } from "../../utils/brandingConfig";
import { getLoaderSvgComponent } from "../../utils/brandingLocalSvgs";

export default function Loader() {
    if (!isBrandingConfigLoaded()) {
      return <></>;
    }

    const LoaderSvg = getLoaderSvgComponent();

    return (
        <>
            <section className="loader-section">
                <div className="box">
                    <div className="svg">
                        <LoaderSvg />
                    </div>
                </div>
            </section>
        </> 
    );
  }
